import { Close } from '@mui/icons-material';
import { Dialog, DialogContent, DialogContentText, DialogTitle, IconButton, Link } from '@mui/material';

export const CrossBoardAgreementDialog: React.FC<{
  open: boolean;
  onClose: () => void;
}> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogTitle className="flex! items-center justify-between">
        [필수] 개인정보의 국외 이전 및 제 3자제공
        <IconButton aria-label="close" onClick={onClose}>
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <DialogContentText>
          <ul>
            <li>개인정보를 이전받는 자: Lenovo affiliates</li>
            <li>개인정보가 이전되는 국가 : 홍콩/미국/중국/영국/말레이시아</li>
            <li>
              이전되는 개인정보 항목 : 이름, 이메일 주소 같은 프로필 정보를 포함하여 레노버 코리아가 처리하는 모든
              데이터
            </li>
            <li>개인정보 이용목적 : 온라인 서비스 제공</li>
            <li>
              개인정보의 보유 및 이용기간 : 보유기간의 경과, 처리목적 달성 시 (단, 법령에 따라 개인정보를 보존하여야
              하는 경우에는 해당 법령에 따름)
            </li>
            <li>개인정보가 이전되는 시기 및 방법 : 서비스 사용 시 네트워크를 통해 전송</li>
            <li>
              정보관리책임자의 연락처 :&nbsp;
              <Link href="mailto:privacy@lenovo.com">privacy@lenovo.com</Link>
            </li>
            <li>
              개인정보 이전을 거부하는 방법, 절차 및 거부의 효과 : 개인정보의 국외 이전을 거부하고자 하시는 경우에는
              회원탈퇴를 하시기 바랍니다. 다만, 국외 이전을 거부하시는 경우 레노버 계정을 이용하지 못할 수도 있고,
              레노버의 제품을 구매하지 못할 수 있으며, 레노버 플랫폼 내 특정 기능 또는 귀하가 요청하는 서비스를 이용하지
              못할 수도 있습니다.
            </li>
          </ul>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};
